import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import envUtil from '../utils/env.util'
import routes from '../routes/routes'
import storageService from '../services/storage.service'
import userApi, { UserSignInRequest } from '../apis/user.api'
import Page from '../components/Page'
import Maintenance from '../components/Maintenance'
import SignInCard from '../components/SignInCard'
import { i18n } from "../i18n/i18n";
import LanguageSelector from '../i18n/LanguageSelector'

interface SignInProps extends RouteComponentProps {}

interface SignInState {
  username: string
  password: string
}

class SignIn extends Component<SignInProps, SignInState> {
  constructor (props: SignInProps) {
    super(props)
    this.state = {
      username: '',
      password: '',
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSignInClick = this.handleSignInClick.bind(this)
  }

  get wrapperClass () {
    const padding = envUtil.isMaintenanceScheduled ? 'pt-5' : 'pt-20'
    return `${padding}`
  }

  get contactLink () {
    return (
      <a className='text-blue-700' href='mailto:hello@quandopro.com'>{i18n("Contact us")}</a>
    )
  }

  signIn () {
    const { username, password } = this.state
    const payload: UserSignInRequest = {}
    if (username) payload.username = username.trim()
    if (password) payload.password = password.trim()
    userApi.signIn(payload, data => {
      if (!data) return
      storageService.set('authToken', data.token)
      storageService.set('isLabelBuilder',data.isLabelUser)
      storageService.set('inTrial',data.inTrial)
      this.props.history.push(routes.dashboard)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'username') this.setState({ username: value })
    if (name === 'password') this.setState({ password: value })
  }

  handleSignInClick () {
    this.signIn()
  }

  handleResetPasswordClick = () => {
    this.props.history.push(routes.resetPassword)
  }

  render () {
    return (
      <Page size='half' wrapperClass={this.wrapperClass}>
        <Maintenance />
        <LanguageSelector/>
        <SignInCard
          heading={i18n("Welcome to QPRO+")}
          username={this.state.username}
          password={this.state.password}
          progress={false}
          onInputChange={this.handleInputChange}
          onSignInClick={this.handleSignInClick}>
          <p className="text-xs mt-5">
            <span className='text-secondary'>{i18n("Forgot password? ")}</span>
            <span
              className='text-blue-700 cursor-pointer'
              onClick={this.handleResetPasswordClick}>{i18n("Reset password")}</span>.
          </p>
          <p className="text-xs text-secondary mt-1">
            {i18n("Not a customer yet?")}&nbsp;
            {this.contactLink}.
          </p>
        </SignInCard>
      </Page>
    )
  }
}

export default withRouter(SignIn)
